module.exports = __webpack_public_path__ + "img/c2.8c9a669d.svg";